import {eventChannel} from 'redux-saga';
import {select, take} from 'redux-saga/effects';
import keycloakAuth from '../../keycloakAuth';
import config from '../../config';

const provideKeycloakTokenToServicesFlow = function* provideKeycloakTokenToServicesFlow() {
    const {serviceManager} = yield select(state => state.application);

    const authSessionEventChannel = eventChannel(emitter => {
        // returns unsubscribe method to eventChannel
        return keycloakAuth.onAuthSessionStarted(sessionCredentials => {
            emitter({sessionCredentials});
        });
    });

    while (true) {
        const {sessionCredentials} = yield take(authSessionEventChannel);

        try {
            const userProfileService = serviceManager.loadService('userProfileService');
            userProfileService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const membersService = serviceManager.loadService('membersService');
            membersService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const ecsFlowService = serviceManager.loadService('ecsFlowService');
            ecsFlowService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const efFileAssetsService = serviceManager.loadService('efFileAssetsService');
            efFileAssetsService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const ehmFileAssetsService = serviceManager.loadService('ehmFileAssetsService');
            ehmFileAssetsService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const apmFileAssetsService = serviceManager.loadService('apmFileAssetsService');
            apmFileAssetsService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const ecsTaskManagementService = serviceManager.loadService('ecsTaskManagementService');
            ecsTaskManagementService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const ecsHistoryManagementService = serviceManager.loadService('ecsHistoryManagementService');
            ecsHistoryManagementService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const partnerManagementService = serviceManager.loadService('partnerManagementService');
            partnerManagementService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        try {
            const silverDATService = serviceManager.loadService('silverDATService');
            silverDATService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }

        if (!config.IS_FALLBACK_SYSTEM) {
            try {
                const datafactoryService = serviceManager.loadService('datafactoryService');
                datafactoryService.setAccessToken(sessionCredentials.accessToken);
            } catch (e) {
                // no-op
            }
        }

        try {
            const pricingManagementService = serviceManager.loadService('pricingManagementService');
            pricingManagementService.setAccessToken(sessionCredentials.accessToken);
        } catch (e) {
            // no-op
        }
    }
};

export default provideKeycloakTokenToServicesFlow;
